'use strict';

var stats = angular.module('gymsystem.stats', []);

stats.controller('StatisticsCtrl', ['$rootScope', '$scope', '$http', '$location', '$filter', 'googleChartApiPromise', 'util', function($rootScope, $scope, $http, $location, $filter, googleChartApiPromise, util) {
    var date = new Date();
    var dateFirstDayMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    $scope.todayDate = date.yyyymmdd();
    var yesterdayDate = new Date();
    yesterdayDate.setDate(yesterdayDate.getDate()-1);
    $scope.yesterdayDate = yesterdayDate.yyyymmdd();

    $http.get('/api/stats/sms?fromDate='+dateFirstDayMonth.yyyymmdd()).success(function(data) {
        $scope.sentSMS = data;
    });
    $http.get('/api/stats/entry?fromDate='+date.yyyymmdd()+'&toDate='+date.yyyymmdd()+'&total=true').success(function(data) {
        $scope.todayEntry = data;
    });

    $http.get('/api/stats/entry?fromDate='+yesterdayDate.yyyymmdd()+'&toDate='+yesterdayDate.yyyymmdd()+'&total=true').success(function(data) {
        $scope.yesterdayEntry = data;
    });

    $http.get('/api/stats/entry?total=true').success(function(data) {
        $scope.totalEntry = data;
    });

    var dateFirstDayLastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    var dateLastDayLastMonth = new Date(date.getFullYear(), date.getMonth(), 0);
    $http.get('/api/stats/sold?fromDate='+dateFirstDayLastMonth.yyyymmdd()+'&toDate='+dateLastDayLastMonth.yyyymmdd()).success(function(data) {
        $scope.sold = data;
    });

    $scope.getLastMonthName = function() {
        var d = new Date();
        d.setMonth(d.getMonth() - 1);
        var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return monthNames[d.getMonth()];
    };

    $scope.clickMember = function(customer) {
        $location.path('/customer/show/' + customer.id);
    };

    $http.get('/api/stats/entry/week').success(function(data) {
        googleChartApiPromise.then(function() {
            var dataObj =  google.visualization.arrayToDataTable([['Title', 'Number'],
                [$filter('translate')('Monday'),data[0]], [$filter('translate')('Tuesday'), data[1]],[$filter('translate')('Wednesday'),data[2]], [$filter('translate')('Thursday'), data[3]],[$filter('translate')('Friday'),data[4]], [$filter('translate')('Saturday'), data[5]],[$filter('translate')('Sunday'),data[6]]]);
            $scope.weeklyObject = {
                "type": "PieChart",
                "displayed": true,
                "data": dataObj,
                "options": {
                    is3D: true,
                    chartArea: {width: '100%', height: '100%'}
                }
            };
        });
    });

    $http.get('/api/stats/member/active').success(function(data) {
        $scope.activeMember = data;
    });

    $scope.generateGenderChart = function() {
        var data = [['Title','Number']];

        var a = { Male: 0, Female: 0, Unknown: 0};

        var customers = $rootScope.members.filter(function(customer) { return !customer.company; });
        for (var i=0; i < customers.length; ++i) {
            var customer = customers[i];
            if (util.isValidPersonalCode(customer.personalCodeNumber)) {
                if (customer.personalCodeNumber[10] % 2 == 0) {
                    a.Female++;
                } else {
                    a.Male++;
                }
            }
            else {
                a.Unknown++;
            }
        }
        data.push([$filter('translate')('Female'), a.Female]);
        data.push([$filter('translate')('Male'), a.Male]);
        if (a.Unknown) {
            data.push([$filter('translate')('Unknown'), a.Unknown]);
        }

        var dataObj =  google.visualization.arrayToDataTable(data);
        $scope.genderObject = {
            "type": "PieChart",
            "displayed": true,
            "data": dataObj,
            "options": {
                is3D: true,
                chartArea: {width: '100%', height: '100%'}
            }
        };
    };

    $http.get('/api/stats/cardtypes?type=workout').success(function(data) {
        $rootScope.waitFor(['trainingcardtypes']).then(function() {
            googleChartApiPromise.then(function() {
                $scope.cardTypeObject = $scope.generateCardTypeChart(data);
            });
        });
    });

    $scope.generateCardTypeChart = function(cardtypes) {
        var data = [['Title','Number']];
        angular.forEach(cardtypes, function(cardtype) {
            var name = _.findWhere($rootScope.trainingcardtypes, {id: cardtype.id}).name;
            data.push([name, cardtype.count]);
        });

        var dataObj =  google.visualization.arrayToDataTable(data);
        return {
            "type": "PieChart",
            "displayed": true,
            "data": dataObj,
            "options": {
                is3D: true,
                chartArea: {width: '100%', height: '100%'}
            }
        };
    };

    var oneMonthBack = new Date();
    oneMonthBack.setMonth(oneMonthBack.getMonth() - 1);
    var now = new Date();
    $http.get('/api/stats/cardtypes?type=workout&fromDate=' + oneMonthBack.yyyymmdd() + '&toDate=' + now.yyyymmdd()).success(function(data) {
        $rootScope.waitFor(['trainingcardtypes']).then(function() {
            googleChartApiPromise.then(function() {
                $scope.workoutCardTypeLastMonthObject = $scope.generateCardTypeChart(data);
            });
        });
    });

    $http.get('/api/stats/cardtypes?type=resourcebooking&fromDate=' + oneMonthBack.yyyymmdd() + '&toDate=' + now.yyyymmdd()).success(function(data) {
        $rootScope.waitFor(['trainingcardtypes']).then(function() {
            googleChartApiPromise.then(function() {
                $scope.resourceBookingCardTypeLastMonthObject = $scope.generateCardTypeChart(data);
            });
        });
    });

    $http.get('/api/stats/cardtypes?type=product&fromDate=' + oneMonthBack.yyyymmdd() + '&toDate=' + now.yyyymmdd()).success(function(data) {
        $rootScope.waitFor(['trainingcardtypes']).then(function() {
            googleChartApiPromise.then(function() {
                $scope.productCardTypeLastMonthObject = $scope.generateCardTypeChart(data);
            });
        });
    });

    $rootScope.waitFor(['members', 'trainingcardtypes']).then(function() {
        googleChartApiPromise.then(function() {
            $scope.generateGenderChart();
        });
    });
}]);

stats.controller('StatisticsEntryListCtrl', ['$rootScope', '$scope', '$http', '$location', '$filter', '$controller', '$routeParams', function($rootScope, $scope, $http, $location, $filter, $controller, $routeParams) {
    $controller('EntryListCtrl', {$scope: $scope});

    $scope.tableConfig.getItems = function() {
        return $scope.entries;
    };
    $scope.tableConfig.itemFilter = null;

    $scope.entries = [];
    $scope.data = { date : ''};

    $scope.setDate = function(date) {
        $location.search('date', date.yyyymmdd() );
        $scope.updateList();
    };

    $scope.updateList = function() {
        var date = $scope.data.date;
        $http.get('/api/entry/get?fromDate=' + date.yyyymmdd()  + '&toDate=' + date.yyyymmdd() + '&idOnly=true' ).success(function(entries) {
            $rootScope.waitFor(['members']).then(function() {
                angular.forEach(entries, function(e) {
                    $rootScope.transformEntry(e);
                });
                $scope.entries = entries;
            });
        });
    };

    // A favourite stores only the path, so the date can be absent. The product
    // navigates here with today, and today is therefore the default.
    var dateObj = Date.newFull($routeParams.date) || Date.today();
    $scope.data = { date : dateObj};
    $scope.updateList();
}]);

stats.controller('ReportCtrl', ['$rootScope', '$scope', '$http', '$filter', '$q', 'server', 'util', 'formatter', 'paymentMethods', 'pdf', 'alertProvider', '$timeout', 'genders', function($rootScope, $scope, $http, $filter, $q, server, util, formatter, paymentMethods, pdf, alertProvider, $timeout, genders) {
    $scope.loadingStatus = {};

    var reportId = function() {
        var report = _.findWhere($scope.fields, {name: 'report'}).value;
        return report && report.id;
    };

    var isVisible = function(field) {
        var report = _.findWhere($scope.fields, {name: 'report'}).value;
        if(!report || !report.fields) {return false;}
        return report.fields.indexOf(field.name) >= 0;
    };

    var isCheckoutReport = function() {
        var log = _.findWhere($scope.fields, {name: 'report'}).value;
        return log && (log.id == 'z' || log.id == 'x' || log.id == 'checkoutevents' || log.id == 'checkoutreceipts');
    };

    var isNotX = function() {
        var log = _.findWhere($scope.fields, {name: 'report'}).value;
        return !(log && (log.id == 'x'));
    };

    var isPayrollDetails = function() {
        var log = _.findWhere($scope.fields, {name: 'report'}).value;
        return log && log.id == 'payrolldetails';
    };

    var isExpiredValueCards = function() {
        var log = _.findWhere($scope.fields, {name: 'report'}).value;
        return log && log.id == 'expiredvaluecards';
    };

    var showWeek = function() {
        var log = _.findWhere($scope.fields, {name: 'report'}).value;
        return log && log.date_type == 'week';
    };

    var showFromDate = function(field) {
        var log = _.findWhere($scope.fields, {name: 'report'}).value;
        return isVisible(field) || isNotX() && log && !isPayrollDetails() && (!log.date_type || log.date_type == 'day');
    };

    var showToDate = function(field) {
        var log = _.findWhere($scope.fields, {name: 'report'}).value;
        return isVisible(field) || isNotX() && !isPayrollDetails() && log && !log.date_type;
    };

    var showMonth = function(field) {
        if(isVisible(field)) {return true;}
        var log = _.findWhere($scope.fields, {name: 'report'}).value;
        return log && log.date_type == 'month';
    };

    var isKorpenMembership = function() {
        var log = _.findWhere($scope.fields, {name: 'report'}).value;
        return log && log.id == 'Korpen medlemskap';
    };

    var tempChainAssociations = [];
    var chainAssociations = [];
    if ($rootScope.is_korpen) {
        server.get('/api/korpen/companies/get').then(function(result) {
            tempChainAssociations = result.map(function(c) { return {id: c.hostname, name: c.name}; });
            chainAssociations = tempChainAssociations;
            chainAssociations.unshift({id: 'selectAll', name: 'Select all'}, {id: 'removeAll', name: 'Remove all'});
        });
    }
    var getChainAssociations = function() {
        return chainAssociations;
    };

    var checkSelectedOption = function() {
        var selectedAssociations = _.findWhere($scope.fields, {name: 'associations'}).value;
        if (selectedAssociations.length && selectedAssociations[0].id === 'selectAll') {
            $timeout(function() {
                _.findWhere($scope.fields, {name: 'associations'}).value = chainAssociations.slice(2, chainAssociations.length);
            }, 10);
        } else if (selectedAssociations.length && selectedAssociations[0].id === 'removeAll') {
            $timeout(function() {
                var target = _.findWhere($scope.fields, {name: 'associations'});
                delete target.value;
            }, 10);
        }
    };

    $scope.ages = [];
    for (var i = 1; i <= 100; ++i) {
        $scope.ages.push({'id': i, 'name': i});
    }

    $scope.getIntervalUnit = function() { return 'years'; };

    function getActiveStaffs() {
        if ($rootScope.speedy) {
            if (!$scope.staffsLoaded) {
                $scope.staffsLoaded = true;
                server.get('/api/staff/get', {site_id: $rootScope.selectedSite.id, inactive: false, compact: true, fields: 'id'}).then(staffs => {
                    staffs.forEach($rootScope.getMember);
                });
            }
        }

        return $rootScope.getActiveStaffs();
    }

    var defaultFields = [
        {name: 'fromDate', title: 'From', required: true, type: 'date', value: Date.today(), visible: showFromDate },
        {name: 'fromDate', title: 'From', required: true, type: 'date', value: Date.firstDayLastMonth(), visible: isPayrollDetails },
        {name: 'toDate', title: 'To', required: true, type: 'date', value: Date.today(), visible: showToDate },
        {name: 'toDate', title: 'To', required: true, type: 'date', value: Date.lastDayLastMonth(), visible: isPayrollDetails },
        {name: 'month', title: 'Month', required: true, type: 'month', value: Date.firstDayLastMonth(), visible: showMonth },
        {name: 'week', title: 'Week', required: true, type: 'week', value: Date.today(), visible: showWeek },
        {name: 'cashier', title: 'Cashier', required: true, type: 'cashier', visible: isCheckoutReport },
        {name: 'legal_entity', title: 'Legal entity', type: 'legal_entity', visible: function() { return isExpiredValueCards() && $rootScope.hasModule('MultipleLegalEntities'); } },
        {name: 'staff', title: 'Staff', required: false, type: 'select', options: getActiveStaffs, placeholder: 'Choose staff', visible: function() {return reportId() == 'workoutbookings';} },
        {name: 'cardtypes', title: 'Products', type: 'multiselect', useId: true, options: function() {return $rootScope.trainingcardtypes;}, visible: isVisible},
        {name: 'associations', title: 'Associations', type:'multiselect', options: getChainAssociations, visible: isKorpenMembership, useId: true, placeholder: 'All', change: checkSelectedOption },
        {name: 'age', title: 'Age', type: 'interval', visible: isKorpenMembership, required: true, options: function() { return $scope.ages; } },
        {name: 'gender', title: 'Gender', required: false, type: 'select', options: genders.getList, useId: true, visible: isKorpenMembership, placeholder: 'Både män och kvinnor'},
        {name: 'tags', title: 'Tags', required: false, type: 'systemtag', visible: () => reportId() == 'trainingcards'}
    ];

    function onChangeReport() {
        var reportField = _.findWhere($scope.fields, {name: 'report'});
        if (reportField.value && reportField.value.custom_fields) {
            $scope.fields = reportField.value.custom_fields.slice().map(function(field) {
                if (field.options && !angular.isFunction(field.options)) {
                    var opts = field.options;
                    field = angular.copy(field);
                    field.options = function() { return opts; };
                }
                if (field.type === 'select' && !angular.isFunction(field.group)) {
                    field.group = function() { return undefined; };
                }
                return field;
            });

            $scope.fields.forEach(function(field) {
                if (!field.options_url) { return; }
                if (field.depends_on) {
                    var parentField = _.findWhere($scope.fields, {name: field.depends_on});
                    if (!parentField) { return; }
                    field.options = function() { return []; };
                    var previousChange = parentField.change;
                    parentField.change = function(f) {
                        field.value = null;
                        field.options = function() { return []; };
                        if (parentField.value && parentField.value.id) {
                            var params = {};
                            params[field.depends_on] = parentField.value.id;
                            server.get('/api' + field.options_url, params).then(function(result) {
                                field.options = function() { return result; };
                            });
                        }
                        if (previousChange) { previousChange(f); }
                    };
                } else {
                    field.options = function() { return []; };
                    server.get('/api' + field.options_url).then(function(result) {
                        field.options = function() { return result; };
                    });
                }
            });
        } else {
            $scope.fields = defaultFields.slice();
        }
        $scope.fields.unshift(reportField);
    }

    $scope.fields = [
        {name: 'report', title: 'Report', required: true, type: 'select', options: function() { return $scope.reports; }, orderPredicate: 'translated', change: onChangeReport }
    ];

    $scope.getButtonText = function() {
        return 'Get report';
    };
    $scope.hideRequired = true;

    $scope.input = {
        report: null
    };

    $scope.soldcards = [];
    $scope.payments = [];

    var getSoldCards = function(item) {
        $scope.loadingStatus.loading = true;
        $http.get('/api/stats/trainingcards/sold?fromDate=' + item.fromDate.yyyymmdd() + '&toDate=' + item.toDate.yyyymmdd()).success(function(result) {
            angular.forEach(result.cards, function(r) {
                r.member = $rootScope.getMember(r.member_id);
                if (!r.member) {
                    r.member = {name: $filter('translate')('Anonymous')};
                }
                r.cardtype = $rootScope.getPointerById(r.cardtype_id, $rootScope.trainingcardtypes);
                r.created = Date.newFull(r.created);
            });
            $scope.soldcards = result.cards;
            var c = {};
            var numSoldCards = 0;
            angular.forEach($scope.soldcards, function(card) {
                if (!c[card.cardtype_id]) {
                    c[card.cardtype_id] = 0;
                }
                c[card.cardtype_id] += (Number(card.count) || 1);
                numSoldCards += (Number(card.count) || 1);
            });

            $scope.soldcardtypes = [];
            $scope.soldcardtypescount = {};
            angular.forEach(_.keys(c), function(cardtype_id) {
                cardtype_id = Number(cardtype_id);
                $scope.soldcardtypes.push($rootScope.getPointerById(cardtype_id, $rootScope.trainingcardtypes));
                $scope.soldcardtypescount[cardtype_id] = c[cardtype_id];
            });

            var summary = [{title: 'Number of sold products', value: numSoldCards}];
            _.forEach($scope.soldcardtypes, function(c) {
                summary.push({title: c.name, value: $scope.soldcardtypescount[c.id]});
            });

            $scope.loaded.report = _.findWhere($scope.reports, {id: 'sold'});
            $scope.loaded.report.summary = summary;

            $scope.loadingStatus.loading = false;
        });
    };

    var getTrainingcards = function(item) {
        $scope.loadingStatus.loading = true;
        let tags = item.tags?.map(x => x.id).join(',');
        server.get('/api/stats/trainingcards/sold', {fromDate: item.fromDate.yyyymmdd(), toDate: item.toDate.yyyymmdd(), tags}).then(function(data) {
            var summary = [
                {title: 'Number of active - start of period', value: data.trainingcards.start},
                {title: 'Number of active - end of period', value: data.trainingcards.end},
                {title: 'Number of sold cards', value: data.trainingcards.sold},
                {title: 'Number of cancelled cards', value: data.trainingcards.cancelled},

                {title: '', value: ''},

                {title: 'Number of active memberships - start of period', value: data.memberships.start},
                {title: 'Number of active memberships - end of period', value: data.memberships.end},
                {title: 'Number of sold memberships', value: data.memberships.sold},
                {title: 'Number of cancelled memberships', value: data.memberships.cancelled}
            ];

            $scope.loaded.report = _.findWhere($scope.reports, {id: 'trainingcards'});
            $scope.loaded.report.summary = summary;
            $scope.loaded.report.items = data.overview;
            $scope.loadingStatus.loading = false;
        });
    };

    var getPayments = function(item) {
        $scope.loadingStatus.loading = true;
        $http.get('/api/stats/payments?fromDate=' + item.fromDate.yyyymmdd() + '&toDate=' + item.toDate.yyyymmdd()).success(function(result) {
            angular.forEach(result, function(r) {
                r.payer = $rootScope.getMember(r.payer_id);
                if (!r.payer) {
                    r.payer = {name: $filter('translate')('Anonymous')};
                }
                r.time = Date.newFull(r.time);
                r.vatcalc = Number(r.amount) - (Number(r.amount) / (1 + Number(r.vat) / 100));
            });
            $scope.payments = result;

            var summary = [
                {title: 'Number of payments', value: $scope.payments.length},
                {title: 'Number of unique payers', value: $scope.getNumPayers()},
                {title: 'Number of unique products', value: $scope.getNumProducts()} ];

            angular.forEach(paymentMethods.getAll(), function(method) {
                var amount = $scope.getPaymentsWithMethod(method);
                if (amount) {
                    summary.push( {title: method.name, value: amount, format: 'price'} );
                }
            });

            summary.push( {title: 'Total amount', value: $scope.getPaymentsTotalAmount(), format: 'price'} );
            summary.push( {title: 'VAT', value: $scope.getTotalVAT(), format: 'price'} );

            $scope.loaded.report = _.findWhere($scope.reports, {id: 'payments'});
            $scope.loaded.report.summary = summary;

            $scope.loadingStatus.loading = false;
        });
    };

    var getWorkoutBookings = function(item) {
        $scope.loadingStatus.loading = true;
        server.get('/api/stats/workouts', {fromDate: item.fromDate.yyyymmdd(), toDate: item.toDate.yyyymmdd()}).then(function(result) {
            var workouts = [];
            var numPresent = 0;
            var numBooked = 0;

            _.each(result, function(w) {
                if (!item.staff || _.findWhere(w.instructors, {id: item.staff.id})) {
                    w.time = Date.newFull(w.time);
                    $rootScope.updatePointers(w.instructors, $rootScope.staffs);

                    numPresent += w.participants.present;
                    numBooked += w.participants.booked;
                    workouts.push(w);
                }
            });
            $scope.workoutbookings = workouts;

            var summary = [
                {title: 'Number of workouts', value: workouts.length},
                {title: 'GENERAL_BOOKINGS', value: numBooked},
                {title: 'Present', value: numPresent} ];

            $scope.loaded.report = _.findWhere($scope.reports, {id: 'workoutbookings'});
            $scope.loaded.report.summary = summary;
            $scope.loadingStatus.loading = false;
        });
    };

    $scope.exportTo = function(format) {
        var title = $scope.loaded.report.name;
        var fromDate = $scope.loaded.from;
        var toDate = $scope.loaded.to;
        var config = $scope.loaded.report.config;
        var summary = $scope.loaded.report.summary;

        $scope.loadingStatus[format] = true;
        config.control.exportTo(format, summary).then(function(blob) {
            var extensions = {pdf: 'pdf', excel: 'xlsx', json: 'json'};
            var legal_entity_name = $scope.loaded.legal_entity ? '_' + $scope.loaded.legal_entity.name : '';
            var dateRange = (fromDate && toDate) ? ('_' + fromDate.yyyymmdd() + '_' + $filter('translate')('to') + '_' + toDate.yyyymmdd()) : '';
            var filename = $filter('translate')(title) + dateRange + legal_entity_name +  '.' + extensions[format];
            util.download(filename, null, null, blob);
            $scope.loadingStatus[format] = false;
        });
    };

    var getSubTitle = function() {
        if ($scope.loaded.from && $scope.loaded.to) {
            return $scope.loaded.from.yyyymmdd() + ' ' + $filter('translate')('to') + ' ' + $scope.loaded.to.yyyymmdd();
        }
        return '';
    };

    var soldCardsConfig = {
        getItems: function() {
            return $scope.soldcards;
        },
        hideSearch: true,
        columns: [
            {field: 'created', title: 'Date', format: 'date', width: 60},
            {field: 'member.name', title: 'Customer', width: 150},
            {field: 'count', title: 'Count', width: 50},
            {field: 'cardtype.name', title: 'Product', width: 150}
        ],
        getTitle: function() {
            return 'Sold products';
        },
        getSubTitle: getSubTitle
    };

    var paymentsConfig = {
        getItems: function() {
            return $scope.payments;
        },
        hideSearch: true,
        columns: [
            {field: 'time', title: 'Date', format: 'date', width: 60},
            {field: 'payer.name', title: 'Name', width: 150},
            {field: 'name', title: 'Product', width: 150},
            {field: 'amount', title: 'Amount', format: 'price', width: 60},
            {field: 'vatcalc', title: 'VAT', format: 'price', width: 60}
        ],
        getTitle: function() {
            return 'Payments';
        },
        getSubTitle: getSubTitle
    };

    var workoutBookingsConfig = {
        getItems: function() {
            return $scope.workoutbookings;
        },
        hideSearch: true,
        columns: [
            {field: 'time', title: 'Time', format: 'datetime', width: 100},
            {field: 'instructors', title: 'Instructors', format: 'commaList', width: 300},
            {field: 'participants.booked', title: 'GENERAL_BOOKINGS', width: 80},
            {field: 'participants.present', title: 'Present', width: 80}
        ],
        getTitle: function() {
            return 'Group workout';
        },
        getSubTitle: getSubTitle
    };

    var xConfig = {
        getItems: function() {
            return null;
        },
        hideSearch: true,
        columns: [],
        getTitle: function() {
            return 'X report';
        }
    };

    var zConfig = {
        getItems: function() {
            return null;
        },
        hideSearch: true,
        columns: [],
        getTitle: function() {
            return 'Z report';
        }
    };

    var trainingcardsConfig = {
        getItems: function() {
            return $scope.loaded.report.items;
        },
        hideSearch: true,
        columns: [
            {field: 'name', title: 'Name'},
            {field: 'start', title: 'Number of active - start of period'},
            {field: 'end', title: 'Number of active - end of period'},
            {field: 'sold', title: 'Number of sold'},
            {field: 'cancelled', title: 'Number of cancelled'},
        ],
        getTitle: function() {
            return 'Training cards';
        },
        getSubTitle: getSubTitle
    };

    var jumpConfig = {
        getItems: function() {
            return null;
        },
        hideSearch: true,
        columns: [],
        getTitle: function() {
            return 'Bokningar';
        },
        getSubTitle: function() {
            var dates = $scope.loaded.week.getDateIntervalForWeek();
            return dates[0].yyyymmdd() + ' ' + $filter('translate')('to') + ' ' + dates[1].yyyymmdd();
        }
    };

    var checkoutEventsConfig = {
        getItems: function() {
            return $scope.checkoutevents;
        },
        hideSearch: true,
        columns: [
            { field: 'time', title: 'Time', format: 'datetime', width: 100 },
            { field: 'cashier.name', title: 'Cashier', width: 60 },
            { field: 'data.staff.name', title: 'Staff', width: 100 },
            { field: 'data', title: 'Event data', format: 'json', width: 300 }
        ],
        getTitle: function() {
            return 'Checkout events';
        }
    };

    var receiptConfig = {
        getItems: function() {
            return $scope.receipts;
        },
        countSuffix: function() { return 'receipts'; },
        hideSearch: false,
        columns: [
            { field: 'seqnr', title: 'Receipt number' },
            { field: 'time', title: 'Time', format: 'datetime' },
            { field: 'cashregister', title: 'Cashier' },
            { field: 'staff', title: 'Staff' },
            { field: 'control_unit_type', title: 'Control Unit Type' },
            { field: 'ctuid', title: 'CTUID' },
            { field: 'control_server_id', title: 'Control Unit ID' },
            { field: 'code', title: 'Code' },
            { field: 'amount', title: 'Amount', format: 'price' }
        ],
        getTitle: function() {
            return 'Receipt list';
        }
    };

    var expiredValueCardsConfig = {
        getItems: function() {
            return null;
        },
        hideSearch: true,
        columns: [],
        getTitle: function() {
            return 'Expired value cards and gift cards';
        },
        getSubTitle: getSubTitle
    };

    var customConfig = {
        getItems: function() {
            return $scope.loaded.report.items;
        },
        hideSearch: false,
        columns: [],
        getTitle: function() {
            return $scope.loaded.report.translated;
        }
    };

    var buildXSummary = function(data) {
        var summary = [];
        if (data.reportNumber) {
            summary.push( {title: 'Report number', value: data.reportNumber } );
        }
        summary.push( {title: 'Companyname', value: data.companyname }  );
        summary.push( {title: 'Corporate identity', value: data.companynumber }  );
        summary.push( {title: 'Time', value: data.time }  );
        summary.push( {title: 'Cashier', value: data.cashregister }  );
        summary.push( {title: 'Total sale amount', value: data.sold, format: 'price' } );
        var vats = _.keys(data.vats);
        angular.forEach(vats, function(vat) {
            summary.push( {title: formatter.format('percentNoMult', vat) + ' ' + $filter('translate')('VAT'), value: data.vats[vat], format: 'price' } );
        });

        if(data.soldByGroups) {
            for(var groupName in data.soldByGroups) {
                summary.push( {title: $filter('translate')('Total sale amount') + ' (' + groupName + ')', value: data.soldByGroups[groupName], format: 'price' } );
            }
        }

        summary.push( {title: 'Change amount open', value: data.cashStart, format: 'price' } );
        summary.push( {title: 'Change amount', value: data.cashStop, format: 'price' } );
        summary.push( {title: 'Number of sold products', value: data.numProducts } );
        summary.push( {title: 'Number of sold services', value: data.numServices } );
        summary.push( {title: 'Number of checkout receipts', value: data.numReceipts } );
        summary.push( {title: 'Number of box openings', value: data.numBoxOpens } );
        summary.push( {title: 'Number of receipt copies', value: data.numReceiptCopies } );
        summary.push( {title: 'Amount receipt copies', value: data.receiptCopiesAmount, format: 'price' } );
        summary.push( {title: 'Number of test purchases', value: data.numTest } );
        summary.push( {title: 'Test amount', value: data.testAmount, format: 'price' } );
        var methods = _.keys(data.methods);
        angular.forEach(methods, function(method) {
            var name = method;
            var f = _.findWhere(paymentMethods.getAll(), {id: method});
            if (f) {
                name = $filter('translate')(f.name);
            }
            summary.push( {title:  $filter('translate')('Payment method') + ': ' + name, value: data.methods[method], format: 'price' } );
        });

        var invoicepaymentmethods = _.keys(data.invoicepaymentmethods);
        angular.forEach(invoicepaymentmethods, function(method) {
            var name = method;
            var f = _.findWhere(paymentMethods.getAll(), {id: method});
            if (f) {
                name = $filter('translate')(f.name);
            }
            summary.push( {title: $filter('translate')('Paid invoice') + ', ' + $filter('translate')('Payment method') + ': ' + name, value: data.invoicepaymentmethods[method], format: 'price' } );
        });
        summary.push( {title: 'Number of repurchases', value: data.numRepurchase } );
        summary.push( {title: 'Repurchase amount', value: data.repurchase, format: 'price' } );
        summary.push( {title: 'Discounts', value: data.discount, format: 'price' } );
        summary.push( {title: 'Number of other registrations', value: data.numMisc } );
        summary.push( {title: 'Amount of other registrations', value: data.miscAmount, format: 'price' } );
        summary.push( {title: 'Number of unfinished registrations', value: data.unfinished } );
        summary.push( {title: 'Amount of unfinished registrations', value: data.unfinishedAmount, format: 'price' } );
        summary.push( {title: 'Grand total purchases', value: data.grandtotalPurchases, format: 'price' } );
        summary.push( {title: 'Grand total repurchases', value: data.grandtotalRepurchases, format: 'price' } );
        summary.push( {title: 'Grand total net', value: data.total, format: 'price' } );
        return summary;
    };

    var getX = function(item) {
        server.get('/api/checkout/report/get/x', {cashregister: item.cashier.id }).then(function(data) {
            var summary = buildXSummary(data);
            $scope.loaded.report = _.findWhere($scope.reports, {id: 'x'});
            $scope.loaded.report.summary = summary;
        });
    };

    var getCheckoutEvents = function(item) {
        $scope.loadingStatus.loading = true;
        server.get('/api/checkout/log/get', {fromDate: item.fromDate.yyyymmdd(), toDate: item.toDate.yyyymmdd(), cashregister: item.cashier.id }).then(function(data) {
            angular.forEach(data, function(i) {
                i.time = Date.newFull(i.time);
                i.cashier = $rootScope.getPointerById(i.cashregister_id, $rootScope.cashregisters);
                if (i.data.staff) {
                    i.data.staff.name = i.data.staff.firstname ? (i.data.staff.firstname + " " + i.data.staff.lastname) : i.data.staff.lastname;
                }
            });
            $scope.checkoutevents = data;
            var summary = [];
            summary.push( {title: 'Cashier', value: item.cashier.name + ', ' + item.cashier.regnr } );

            $scope.loaded.report = _.findWhere($scope.reports, {id: 'checkoutevents'});
            $scope.loaded.report.summary = summary;
            $scope.loadingStatus.loading = false;
        });
    };

    var getZ = function(item) {
        $scope.loadingStatus.loading = true;
        var z = _.findWhere($scope.reports, {id: 'z'});
        z.subreports = [];
        z.selected = null;
        z.summary = null;
        server.get('/api/checkout/report/get/z', {fromDate: item.fromDate.yyyymmdd(), toDate: item.toDate.yyyymmdd(), cashregister: item.cashier.id }, null, {responseType: 'blob'}).then(function(data) {
            if(data.size === 0) {
                alertProvider.show('error', 'No reports found within the selected period');
            } else {
                var ext = data.type == 'application/zip' ? 'zip' : 'pdf';
                util.download('Z-dagrapport.' + ext, null, null, data);
            }
            $scope.loadingStatus.loading = false;
        });
    };

    var renderPayrollDetails = function(title, subtitle, staffs) {
        var deferred = $q.defer();
        var doc = new PDFDocument();
        var stream = doc.pipe(blobStream());

        var edgeX = 65;
        angular.forEach(staffs, function(r, index) {
            doc.fontSize(22);
            doc.text($filter('translate')(title), edgeX);
            doc.text($filter('translate')(subtitle), edgeX);
            doc.text(r.name, edgeX);
            doc.fontSize(16);
            doc.moveDown();
            doc.text($filter('translate')('Total scheduled time') + ': ' + Number(r.services.total.toFixed(2)) + ' ' + $filter('translate')('hours'), edgeX);
            doc.moveDown();
            doc.fontSize(22);
            doc.text($filter('translate')('Activities'), edgeX, doc.y);
            doc.fontSize(16);
            doc.text($filter('translate')('Total booked time') + ': ' + Number(r.services.workoutTotal.toFixed(2)) + ' ' + $filter('translate')('hours'), edgeX, doc.y);
            angular.forEach(r.services.workout, function(workout) {
                doc.text(workout.name + ': ' + workout.count + ' st, ' + Number(workout.workhours.toFixed(2)) + ' ' + $filter('translate')('hours'), edgeX, doc.y, {lineBreak: false});
                doc.moveDown();
            });
            doc.moveDown();
            doc.fontSize(22);
            doc.text($filter('translate')('Resource bookings'), edgeX, doc.y);
            doc.fontSize(16);
            doc.text($filter('translate')('Total booked time') + ': ' + Number(r.services.resourceTotal.toFixed(2)) + ' ' + $filter('translate')('hours'), edgeX);
            angular.forEach(r.services.resource, function(resource) {
                doc.text(resource.name + ': ' + resource.count +' st, ' + Number(resource.workhours.toFixed(2)) + ' ' + $filter('translate')('hours'), edgeX, doc.y, {lineBreak: false});
                doc.moveDown();
            });
            if (index < staffs.length -1) {
                doc.addPage();
            }
        });

        doc.end();

        stream.on('finish', function() {
            deferred.resolve(stream.toBlob('application/pdf'));
        });

        return deferred.promise;
    };

    var getPayrollDetails = function(item) {
        $scope.loaded.report = _.findWhere($scope.reports, {id: 'payrolldetails'});
        $scope.loadingStatus.loading = true;

        var fetchStaffs = $rootScope.speedy ?
            server.get('/api/staff/get', {inactive: false, compact: true, fields: 'id'}).then(function(staffList) {
                return $rootScope.getMembersAsync(staffList.map(function(s) { return s.id; })).then(function(members) {
                    return members.filter(function(m) { return m && m.active && !m.resource; });
                });
            })
            : $q.when($rootScope.getActiveStaffs());

        fetchStaffs.then(function(activeStaffs) {
            var dates = '&fromDate=' + item.fromDate.yyyymmdd() + '&toDate=' + item.toDate.yyyymmdd();
            var staffs = [];
            var promises = [];
            angular.forEach(activeStaffs, function(activeStaff) {
                var rbcategories = [];
                var workoutTypes = [];
                var resourceTotalBookedHours = 0;
                var activeStaffWorked = false;
                var promise = $http.get('/api/stats/staff?staff=' + activeStaff.id + dates).success(function(result) {
                    if (result.workouttypes) {
                        activeStaffWorked = (result.workouttypes.length > 0);
                        angular.forEach(result.workouttypes, function(w) {
                            w.workoutType = $rootScope.getPointerById(w.workout_type_id, $rootScope.workouttypes);
                            workoutTypes.push({name: w.workoutType.name, count: w.count, workhours: w.seconds_total/3600});
                        });
                    }

                    if (result.rbcategories) {
                        activeStaffWorked = (activeStaffWorked || result.rbcategories.length > 0);
                        angular.forEach(result.rbcategories, function(cat) {
                            cat.category = $rootScope.getPointerById(cat.category_id, $rootScope.resourcebookingcategories);
                            angular.forEach(cat.services, function(s) {
                                s.service = $rootScope.getPointerById(s.service_id, $rootScope.resourcebookingservices);
                                rbcategories.push({name: s.service.name, count:s.count, workhours:s.count*(s.service.duration/60)});
                                resourceTotalBookedHours += s.count*(s.service.duration/60);
                            });
                        });
                    }
                    if (activeStaffWorked) {
                        staffs.push({ name: activeStaff.name, services:{workout: workoutTypes, resource: rbcategories, total:result.workhours.total, workoutTotal: result.workhours.workouts.total, resourceTotal:resourceTotalBookedHours } });
                    }
                });
                promises.push(promise);
            });
            return $q.all(promises).then(function(){
                $scope.loadingStatus.loading = false;
                return pdf.load().then(function() {
                    return renderPayrollDetails($filter('translate')('Payroll details'), item.fromDate.yyyymmdd() + ' ' + $filter('translate')('to') + ' ' + item.toDate.yyyymmdd(), staffs).then(function(blob) {
                        var filename = $filter('translate')('Payroll details') + '_' + item.fromDate.yyyymmdd() + '_' + $filter('translate')('to') + '_' + item.toDate.yyyymmdd() + '.pdf';
                        util.download(filename, null, null, blob);
                    });
                });
            });
        }).catch(function(error) {
             $scope.loadingStatus.loading = false;
             alertProvider.show('error', $filter('translate')('Failed to load payroll details'));
        });
    };

    $scope.changeZreport = function() {
        var data = $scope.loaded.report.selected.data;
        var summary = buildXSummary(data);
        $scope.loaded.report.summary = summary;
    };

    var renderResourcesPdf = function(title, subtitle, item, resources) {
        var deferred = $q.defer();
        var doc = new PDFDocument();
        var stream = doc.pipe(blobStream());

        doc.fontSize(28);
        doc.text($filter('translate')(title), 20);
        doc.fontSize(20);
        doc.text($filter('translate')(subtitle), 20);

        doc.moveDown();

        var vi = $filter('translate')('VATINCL');
        var vni = $filter('translate')('VATEXCL');
        var v = $filter('translate')('VATlower');

        $rootScope.getMembersAsync(resources.map(r => r.id)).then(() => {
            angular.forEach(resources, function(r) {
                var staff = $rootScope.getStaff(r.id);
                doc.fontSize(16);
                doc.text(staff ? staff.name : ($filter('translate')('Anonymous') + ' ' + r.id), 20);
                doc.fontSize(10);
                doc.text($filter('translate')('Number of workouts') + ': ' + r.workouts, 20);
                doc.moveDown();
                var y = doc.y;
                angular.forEach(r.services, function(service) {
                    var x = 20;
                    doc.text(service.name, x, y, {lineBreak: false, width: 200});
                    var yafter = doc.y;
                    x += 200;
                    doc.text(formatter.format('price', service.price) +  ' ' + vi, x, y, {lineBreak: false });
                    x += 100;
                    doc.text(formatter.format('price', service.vatsum) + ' ' + v, x, y, {lineBreak: false});
                    x += 100;
                    doc.text(formatter.format('price', service.withoutvat) + ' ' + vni, x, y, {lineBreak: false});
                    doc.moveDown();
                    y = yafter;

                    if (y > 650) {
                        doc.addPage();
                        y = doc.y;
                    }
                });
                doc.moveDown();
                angular.forEach(_.keys(r.vats).sort(), function(vat) {
                    var y = doc.y;
                    doc.text($filter('translate')('Total amount') + ' '  + formatter.format('percentNoMult', vat) + ' ' + v, 20, y);
                    doc.text(formatter.format('price', r.vats[vat].amount) + ' ' + vi, 220, y);
                    doc.text(formatter.format('price', r.vats[vat].vatsum) + ' ' + v, 320, y);
                    doc.text(formatter.format('price', r.vats[vat].withoutvat) + ' ' + vni, 420, y);
                });

                doc.moveDown();
            });

            doc.end();
        });

        stream.on('finish', function() {
            deferred.resolve(stream.toBlob('application/pdf'));
        });

        return deferred.promise;
    };

    var getResources = function(item) {
        $scope.loadingStatus.loading = true;
        server.get('/api/stats/resources', {fromDate: item.fromDate.yyyymmdd(), toDate: item.toDate.yyyymmdd()}).then(function(result) {
            $scope.loaded.report = _.findWhere($scope.reports, {id: 'resources'});
            var title = $scope.loaded.report.name;
            var subtitle = getSubTitle();

            pdf.load().then(function() {
                renderResourcesPdf(title, subtitle, item, result.resources).then(function(blob) {
                    var filename = $filter('translate')(title) + '_' + item.fromDate.yyyymmdd() + '_' + $filter('translate')('to') + '_' + item.toDate.yyyymmdd() + '.pdf';
                    util.download(filename, null, null, blob);
                });
            });

            $scope.loadingStatus.loading = false;
        });
    };

    var getApn = function(item) {
        $scope.loadingStatus.loading = true;
        server.post('/api/stats/custom/get', {id: 'apn', fromDate: item.fromDate.yyyymmdd(), toDate: item.toDate.yyyymmdd()}, null, null, null, null, {responseType: 'blob'}).then(function(result) {
            $scope.loaded.report = _.findWhere($scope.reports, {id: 'apn'});

            util.download('Aktivitetsstöd.xlsx', result.data, 'application/vnd.ms-excel');

            $scope.loadingStatus.loading = false;
        });
    };

    var getExpiredValueCards = function(item) {
        $scope.loadingStatus.loading = true;
        var args = {fromDate: item.fromDate.yyyymmdd(), toDate: item.toDate.yyyymmdd()};
        if ($rootScope.hasModule('MultipleLegalEntities') && $rootScope.selectedSite && $rootScope.selectedSite.legal_entity_id) {
            args.legal_entity_id = $rootScope.selectedSite.legal_entity_id;
        }
        server.get('/api/stats/expiredvaluecards', args).then(function(data) {
            $scope.loaded.report = _.findWhere($scope.reports, {id: 'expiredvaluecards'});

            var summary = [];
            const legal_entity = $scope.loaded.legal_entity = $rootScope.sites.find(s => s.legal_entity_id === args.legal_entity_id)?.legal_entity;
            summary.push( {title: 'Number of cards', value: data.count } );
            summary.push( {title: 'Amount', value: data.amount, type: 'price' } );
            if (legal_entity) {
                summary.push( {title: 'Legal entity', value: legal_entity.name } );
                $scope.loaded.legal_entity = legal_entity;
            }
            $scope.loaded.report.summary = summary;

            $scope.loadingStatus.loading = false;
        });
    };

    var getReceipts = function(item) {
        $scope.loadingStatus.loading = true;
        server.get('/api/checkout/report/get/receipts', {fromDate: item.fromDate.yyyymmdd(), toDate: item.toDate.yyyymmdd(), cashregister: item.cashier.id}).then(function(data) {
            angular.forEach(data, function(d) {
                d.time = Date.newFull(d.time);
            });
            $scope.receipts = data;
            $scope.loaded.report = _.findWhere($scope.reports, {id: 'checkoutreceipts'});
            var summary = [];
            summary.push( {title: 'Cashier', value: item.cashier.name + ', ' + item.cashier.regnr } );
            $scope.loaded.report.summary = summary;
            $scope.loadingStatus.loading = false;
        });
    };

    var getJump = function(item) {
        $scope.loadingStatus.loading = true;
        var dates = item.week.getDateIntervalForWeek();
        server.post('/api/stats/custom/get', {id: 'jumpbookings', fromDate: dates[0].yyyymmdd(), toDate: dates[1].yyyymmdd()}).then(function(result) {
            if (result.success) {
                var d = result.data;
                $scope.loaded.report = _.findWhere($scope.reports, {id: 'jumpbookings'});
                var summary = [];
                summary.push( {title: 'Antal hoppare', value: d.count } );
                summary.push( {title: 'Antal kalas', value: d.kalas } );
                summary.push( {title: 'Antal extra kalashoppare', value: d.kalas_extra } );
                summary.push( {title: 'Antal kalashoppare', value: d.kalas_persons } );
                summary.push( {title: 'Antal Fri Hoppning', value: d.fri_hoppning } );
                $scope.loaded.report.summary = summary;
            }

            $scope.loadingStatus.loading = false;
        });
    };

    var customFetch = function(item) {
        $scope.loadingStatus.loading = true;
        var fromDate = item.fromDate && item.fromDate.yyyymmdd();
        var toDate = (item.toDate || item.fromDate);
        toDate = toDate && toDate.yyyymmdd();
        if (item.report.date_type && item.report.date_type == 'month') {
            fromDate = item.month.yyyymmdd();
            toDate = item.month.clone().addMonths(1).addDays(-1).yyyymmdd();
        } else if (item.report.date_type && item.report.date_type == 'week') {
            var dates = item.week.getDateIntervalForWeek();
            fromDate = dates[0].yyyymmdd();
            toDate = dates[1].yyyymmdd();
        }
        server.post('/api/stats/custom/get', {id: item.report.id, fromDate: fromDate, toDate: toDate}).then(function(result) {
            if (result.success) {
                $scope.loaded.report = _.findWhere($scope.reports, {id: item.report.id});
                $scope.loaded.report.summary = result.data;
            }

            $scope.loadingStatus.loading = false;
        });
    };

    var customFetch2 = function(report, item) {
        if(report.response_type === 'file') {
            $scope.loadingStatus.loading = true;
            server.post('/api/stats/custom/get', item, null, null, null, null, {responseType: 'blob'}).then(function(result) {
                $scope.loadingStatus.loading = false;
                if(result.success) {
                    util.download(result.filename || 'report.xlsx', null, null, result.data);
                } else {
                    alertProvider.show('error', 'Error');
                }
            });
        } else if (report.response_type === 'report') {
            $scope.loadingStatus.loading = true;
            var fromDate = Date.newFull(item.fromDate);
            var toDate = Date.newFull(item.toDate || item.fromDate);
            if (report.date_type && report.date_type == 'month') {
                fromDate = Date.newFull(item.month);
                toDate = fromDate.clone().addMonths(1).addDays(-1);
            } else if (report.date_type && report.date_type == 'week') {
                var dates = item.week.getDateIntervalForWeek();
                fromDate = dates[0];
                toDate = dates[1];
            }
            $scope.loaded = {};
            $scope.loaded.from = fromDate;
            $scope.loaded.to = toDate;

            server.post('/api/stats/custom/get', item).then(function(result) {
                if (result.success) {
                    $scope.loaded.report = _.findWhere($scope.reports, {id: item.id});
                    $scope.loaded.from = fromDate;
                    $scope.loaded.to = toDate;

                    $scope.loaded.report.summary = result.data.summary;
                    var items = result.data.items;
                    if (items) {
                        var dateFields = _.filter($scope.loaded.report.fields, function(f) { return ['datetime', 'date', 'time'].indexOf(f.format) !== -1; });
                        dateFields = _.uniq(_.pluck(dateFields, 'field'));
                        angular.forEach(items, function(i) {
                            dateFields.forEach(function(field) {
                                if (!i[field]) { return; }
                                i[field] = Date.newFull(i[field]);
                            });
                        });
                        $scope.loaded.report.items = items;
                    }
                }
                $scope.loadingStatus.loading = false;
            });
        } else {
            throw "Not implemented";
        }
    };

    server.get('/api/stats/custom/list').then(function(customReports) {
        $rootScope.waitFor(['startedModules']).then(function() {
            $scope.reports = [];

            $scope.reports.push({ id: 'sold', name: 'Sold products', fetch: getSoldCards, config: soldCardsConfig });
            $scope.reports.push({ id: 'trainingcards', name: 'Training cards', fetch: getTrainingcards, config: trainingcardsConfig, formats: ['json', 'pdf', 'excel'] });
            if ($rootScope.hasModule('Payment')) {
                $scope.reports.push({ id: 'payments', name: 'Payments', fetch: getPayments, config: paymentsConfig });
            }
            if ($rootScope.hasModule('WorkoutBooking')) {
                $scope.reports.push({ id: 'workoutbookings', name: 'Group workout', fetch: getWorkoutBookings, config: workoutBookingsConfig });
            }

            if ($rootScope.hasModule('Checkout')) {
                $scope.reports.push({ id: 'checkoutevents', name: 'Checkout events', fetch: getCheckoutEvents, config: checkoutEventsConfig, formats: ['json'] });
                $scope.reports.push({ id: 'x', name: 'X report', fetch: getX, config: xConfig, formats: ['json', 'pdf'] });
                $scope.reports.push({ id: 'z', name: 'Z report', fetch: getZ, config: zConfig, formats: ['json', 'pdf'] });
                $scope.reports.push({ id: 'checkoutreceipts', name: 'Receipt list', fetch: getReceipts, config: receiptConfig, formats: ['json', 'excel'] });
            }

            if ($rootScope.hasModule('ResourceBooking') || $rootScope.hasModule('Schedule')) {
                $scope.reports.push({ id: 'resources', name: 'Settlement resources', fetch: getResources, config: null });
            }

            customReports.forEach(function(cr) {
                if (cr.id == 'jumpbookings') {
                    $scope.reports.push({ id: 'jumpbookings', name: 'Bokningar', date_type: cr.date_type, fetch: getJump, config: jumpConfig, formats: ['json', 'pdf'] });
                } else if (cr.id == 'apn') {
                    $scope.reports.push({ id: 'apn', name: 'Aktivitetsstöd', date_type: cr.date_type, fetch: getApn, config: null });
                } else if (cr.fields || cr.custom_fields) {
                    cr.name = cr.id;
                    if (cr.response_type === 'report') {
                        cr.config = _.extend(angular.copy(customConfig), { columns: cr.fields, hideSearch: !!cr.hideSearch });
                    }
                    $scope.reports.push(cr);
                } else {
                    $scope.reports.push({id: cr.id, name: cr.id, date_type: cr.date_type, fetch: customFetch, config: null, formats: []});
                }
            });

            $scope.reports.push({ id: 'expiredvaluecards', name: 'Expired value cards and gift cards', fetch: getExpiredValueCards, config: expiredValueCardsConfig, formats: ['json', 'pdf'] });
            $scope.reports.push({ id: 'payrolldetails', name: 'Payroll details', fetch: getPayrollDetails, config: null, formats: ['json', 'pdf'] });

            angular.forEach($scope.reports, function(r) {
                r.translated = $filter('translate')(r.name);
            });
        });
    });

    $scope.submit = function() {
        var report = _.findWhere($scope.fields, {name: 'report'}).value;
        if(report.fields || report.custom_fields) {
            var item = util.getSubmitItem($scope.fields, report.id);
            delete item.report;
            return customFetch2(report, item);
        }

        var item = {};
        $scope.fields.forEach(function(field) {
            if((field.name === 'fromDate' || field.name === 'toDate') && !field.visible(field)) {return;}
            item[field.name] = field.value;
        });
        if(!item.fromDate) { item.fromDate = item.toDate; }
        $scope.loaded = {
            from: item.fromDate && item.fromDate.clone(),
            to: item.toDate && item.toDate.clone(),
            week: item.week && item.week.clone()
        };
        report.fetch(item);
    };

    var sum = function(list, key) {
        var total = 0;
        angular.forEach(list, function(i) {
            total += Number(i[key]);
        });
        return total;
    };

    // Payments

    $scope.getPaymentsTotalAmount = function() {
        return sum($scope.payments, 'amount');
    };

    $scope.getTotalVAT = function() {
        return sum($scope.payments, 'vatcalc');
    };

    $scope.getNumPayers = function() {
        var c = _.countBy($scope.payments, function(p) { return p.payer.id; });
        return _.keys(c).length;
    };

    $scope.getNumProducts = function() {
        var c = _.countBy($scope.payments, function(p) { return p.name; });
        return _.keys(c).length;
    };

    $scope.getPaymentsWithMethod = function(m) {
        return sum(_.where($scope.payments, {method: m.id}), 'amount');
    };
}]);

stats.controller('StaffStatsCtrl', ['$rootScope', '$scope', '$routeParams', '$http', '$filter', 'googleChartApiPromise', function($rootScope, $scope, $routeParams, $http, $filter, googleChartApiPromise) {
    $scope.dates = {
        from: Date.firstDayLastMonth(),
        to: Date.lastDayLastMonth()
    };

    $scope.stats = {};
    $scope.loadingStatus = {};

    var getWorkoutsTotal = function() {
        return ($scope.stats.workhours.workouts && $scope.stats.workhours.workouts.total) || 0;
    };

    var getResourceBookingTotal = function() {
        return ($scope.stats.workhours.resourcebooking && $scope.stats.workhours.resourcebooking.total) || 0;
    };

    $scope.showWorkHoursChart = function() {
        return $scope.stats.workhours.total > (getWorkoutsTotal() + getResourceBookingTotal());
    };

    var generateWorkHoursChart = function() {
        var data = [['Title','Number']];
        var other = Number(($scope.stats.workhours.total - (getWorkoutsTotal() + getResourceBookingTotal())).toFixed(2));
        if ($scope.stats.workhours.workouts) {
            data.push([$filter('translate')('Workouts'), Number($scope.stats.workhours.workouts.total.toFixed(2))]);
        }
        if ($scope.stats.workhours.resourcebooking) {
            angular.forEach($scope.stats.workhours.resourcebooking.categories, function(cat) {
                data.push([cat.category.name, Number(cat.total.toFixed(2))]);
            });
        }
        data.push([$filter('translate')('General'), other]);

        var dataObj =  google.visualization.arrayToDataTable(data);
        $scope.workHoursChart = {
            "type": "PieChart",
            "displayed": true,
            "data": dataObj,
            "options": {
                is3D: true,
                chartArea: {width: '100%', height: '100%'}
            }
        };
    };

    var generateWorkoutsTableConfig = function() {
        var config = {
            getItems: function() {
                return $scope.stats.workouttypes;
            },
            columns: [
                {field: 'workoutType.name', title: 'Workout type' },
                {field: 'count', title: 'Number of workouts' },
                {field: 'participants_average', title: 'Participants average', format: 'float' },
                {field: 'present_participants_average', title: 'Present participants average', format: 'float' },
                {field: 'occupancy_participants', title: 'Occupancy', format: 'percentage' },
                {field: 'occupancy_present_participants', title: 'Occupancy present', format: 'percentage' }
            ],
            hideSearch: true,
            orderColumn: 'workoutType.name'
        };

        $scope.workoutsTableConfig = config;
    };

    var generateResourceBookingTableConfig = function() {
        var items = [];
        angular.forEach($scope.stats.rbcategories, function(cat) {
            angular.forEach(cat.services, function(service) {
                var i = { category: cat.category.name, service: service.service.name, count: service.count };
                items.push(i);
            });
        });

        var config = {
            getItems: function() {
                return items;
            },
            columns: [
                {field: 'category', title: 'Category' },
                {field: 'service', title: 'Service' },
                {field: 'count', title: 'Count' }
            ],
            hideSearch: true,
            orderColumn: 'category'
        };

        $scope.resourceBookingTableConfig = config;
    };

    $scope.updateStats = function() {
        $scope.loadingStatus.loading = true;
        var f = $scope.dates.from.yyyymmdd();
        var t = $scope.dates.to.yyyymmdd();
        var dates = '&fromDate=' + f + '&toDate=' + t;
        $http.get('/api/stats/staff?staff=' + $scope.staff.id + dates).success(function(result) {
            if (result.workhours.resourcebooking) {
                angular.forEach(result.workhours.resourcebooking.categories, function(cat) {
                    cat.category = $rootScope.getPointerById(cat.category_id, $rootScope.resourcebookingcategories);
                });
            }

            if (result.workouttypes) {
                angular.forEach(result.workouttypes, function(w) {
                    w.workoutType = $rootScope.getPointerById(w.workout_type_id, $rootScope.workouttypes);
                });
            }

            if (result.rbcategories) {
                angular.forEach(result.rbcategories, function(cat) {
                    cat.category = $rootScope.getPointerById(cat.category_id, $rootScope.resourcebookingcategories);
                    angular.forEach(cat.services, function(s) {
                        s.service = $rootScope.getPointerById(s.service_id, $rootScope.resourcebookingservices);
                    });
                });
            }

            $scope.stats = result;

            if ($scope.showWorkHoursChart()) {
                generateWorkHoursChart(result);
            }

            generateWorkoutsTableConfig();
            generateResourceBookingTableConfig();

            $scope.loadingStatus.loading = false;
        });
    };

    googleChartApiPromise.then(function() {
        $rootScope.waitFor(['staffs', 'startedModules']).then(function() {
            $scope.staff = $rootScope.getStaff(Number($routeParams.staffId));
            var waitModules = [];
            if ($rootScope.hasModule('ResourceBooking')) {
                waitModules.push('resourcebookingcategories');
                waitModules.push('resourcebookingservices');
            }
            if ($rootScope.hasModule('Schedule')) {
                waitModules.push('workouttypes');
            }
            $rootScope.waitFor(waitModules).then(function() {
                $scope.updateStats();
            });
        });
    });
}]);

stats.controller('WorkoutTypeStatisticsCtrl', ['$rootScope', '$scope', '$http', '$filter', 'googleChartApiPromise', 'workoutType', 'util', function($rootScope, $scope, $http, $filter, googleChartApiPromise, workoutType, util) {
    $scope.titleSuffix = function() {
        return workoutType.name;
    };

    $scope.dates = {
        from: Date.firstDayLastMonth(),
        to: Date.lastDayLastMonth()
    };

    $scope.times = {
        from: null,
        to: null
    };

    $scope.loaded = {};
    $scope.stats = {};
    $scope.loadingStatus = {};

    $scope.statsSummary = [
        {title: 'Number of workouts'},
        {title: 'Cancelled workouts', visible: function(item) { return item.value; } },
        {title: 'Registered'},
        {title: 'Present'},
        {title: 'Participants per workout', format: 'float'},
        {title: 'Occupancy', format: 'percentage'},
        {title: 'Occupancy present', format: 'percentage'}
    ];

    var getSubTitle = function() {
        var result = $scope.loaded.fromDate.yyyymmdd() + ' ' + $filter('translate')('to') + ' ' + $scope.loaded.toDate.yyyymmdd();
        if ($scope.loaded.fromTime && $scope.loaded.toTime) {
            result += ', ' + $scope.loaded.fromTime.hhmm() + ' ' + $filter('translate')('to') + ' ' + $scope.loaded.toTime.hhmm();
        }
        return result;
    };

    $scope.staffsConfig = {
        getItems: function() {
            return $scope.stats.staffs;
        },
        hideSearch: true,
        orderColumn: 'workouts',
        columns: [
            {field: 'image', title: '', src: function(s) { return $scope.smallStaffImage(s.staff); }  },
            {field: 'staff.name', title: 'Name', width: 200},
            {field: 'workouts', title: 'Number of workouts', width: 150},
            {field: 'occupancy', title: 'Occupancy', format: 'percentage', width: 100}
        ],
        rowClick: function(s) {
            $scope.$close();
            $rootScope.gotoStaff(s.staff);
        },
        getTitle: function() {
            return workoutType.name;
        },
        getSubTitle: getSubTitle
    };

    $scope.exportTo = function(format) {
        var title = workoutType.name;
        var fromDate = $scope.loaded.fromDate;
        var toDate = $scope.loaded.toDate;
        var config = $scope.staffsConfig;
        var summary = $scope.statsSummary;

        $scope.loadingStatus[format] = true;
        config.control.exportTo(format, summary).then(function(blob) {
            var extensions = {pdf: 'pdf', excel: '.xlsx', json: 'json'};
            var filename = title + '_' + fromDate.yyyymmdd() + '_' + $filter('translate')('to') + '_' + toDate.yyyymmdd() + '.' + extensions[format];
            util.download(filename, null, null, blob);
            $scope.loadingStatus[format] = false;
        });
    };

    $scope.updateStats = function() {
        $scope.loadingStatus.loading = true;
        var f = $scope.dates.from.yyyymmdd();
        var t = $scope.dates.to.yyyymmdd();
        var dates = '&fromDate=' + f + '&toDate=' + t;
        var times = '';
        if ($scope.times.from) {
            times += '&fromTime=' + $scope.times.from.hhmm();
        }
        if ($scope.times.to) {
            times += '&toTime=' + $scope.times.to.hhmm();
        }

        $http.get('/api/stats/workouttypes?workouttype=' + workoutType.id + dates + times).success(function(result) {
            angular.forEach(result.staffs, function(s) {
                s.staff = $rootScope.getPointerById(s.id, $rootScope.staffs);
            });
            $scope.stats = result;

            var sum = $scope.statsSummary;
            sum[0].value = result.workouts;
            sum[1].value = result.cancelled;
            sum[2].value = result.participants;
            sum[3].value = result.present_participants;
            sum[4].value = result.participants_average;
            sum[5].value = result.occupancy;
            sum[6].value = result.occupancy_present;

            $scope.loaded.fromDate = $scope.dates.from;
            $scope.loaded.toDate = $scope.dates.to;
            $scope.loaded.fromTime = $scope.times.from;
            $scope.loaded.toTime = $scope.times.to;

            $scope.loadingStatus.loading = false;
        });
    };

    $scope.updateStats();
}]);

stats.controller('GraphStatsCtrl', ['$scope', function($scope) {
    $scope.views = ['Months', 'Days', 'Week days', 'Hours' ];

    var years = 3;
    var fromDate = new Date();
    fromDate.setFullYear(fromDate.getFullYear() - (years-1));
    fromDate.setMonth(0);
    fromDate.setDate(1);
    var toDate = Date.firstDayThisMonth();

    $scope.input = { from: fromDate, to: toDate, view: $scope.views[0] };
}]);

stats.controller('MostActiveWorkoutsStatsCtrl', ['$rootScope', '$scope', '$q', 'server', function($rootScope, $scope, $q, server) {
    var date = new Date();
    var dateFirstDayLastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    var dateLastDayLastMonth = new Date(date.getFullYear(), date.getMonth(), 0);
    $scope.input = { from: dateFirstDayLastMonth, to: dateLastDayLastMonth };

    $scope.topMemberWorkouts = [];
    var cancelPreviousRequest = null;

    $scope.getStats = function() {
        if (cancelPreviousRequest) {
            cancelPreviousRequest.resolve();
        }

        if ($scope.input.from.getFullYear() < 2000 || $scope.input.to.getFullYear() < 2000) {
            return;
        }

        cancelPreviousRequest = $q.defer();

        var args = {num: 10, fromDate: $scope.input.from.yyyymmdd(), toDate: $scope.input.to.yyyymmdd() };
        server.get('/api/stats/workout/topMembers', args, cancelPreviousRequest).then(function(data) {
            $rootScope.waitFor(['members']).then(function() {
                angular.forEach(data, function(visit) {
                    visit.member = $rootScope.getMember(visit.member_id);
                });
                $scope.topMemberWorkouts = data;
            });
        });
    };

    $scope.getStats();
}]);

stats.controller('MostActiveEntryStatsCtrl', ['$rootScope', '$scope', '$q', '$controller', 'server', function($rootScope, $scope, $q, $controller, server) {
    $controller('AddCtrl', {$scope: $scope});

    var date = new Date();
    var dateFirstDayLastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    var dateLastDayLastMonth = new Date(date.getFullYear(), date.getMonth(), 0);

    $scope.topMemberEntries = [];
    var cancelPreviousRequest = null;

    var isActiveDoor = function(s) {
        return s.active && s.type == 'resource' && s.resourceType == 'door';
    };

    $scope.hasDoors = function() {
        return $rootScope.staffs.filter(isActiveDoor).length > 0;
    };

    $scope.getDoors = function() {
        return $rootScope.staffs.filter(isActiveDoor);
    };

    $scope.getStats = function() {
        if (cancelPreviousRequest) {
            cancelPreviousRequest.resolve();
        }

        var args = $scope.getSubmitItem();
        args.fromDate = args.period.from;
        args.toDate = args.period.to;
        delete args.period;

        if (Date.newFull(args.fromDate).getFullYear() < 2000 || Date.newFull(args.toDate).getFullYear() < 2000) {
            return;
        }

        cancelPreviousRequest = $q.defer();

        server.get('/api/stats/entry/topMembers', args, cancelPreviousRequest).then(function(data) {
            $rootScope.waitFor(['members']).then(function() {
                var id = 1;
                angular.forEach(data, function(visit) {
                    visit.member = $rootScope.getMember(visit.member_id);
                    visit.id = id;
                    ++id;
                });
                $scope.topMemberEntries = data;
            });
        });
    };

    $scope.fields = [
        {name: 'period', title: 'Period', title2: 'to', type: 'dateinterval', change: $scope.getStats, value: {from: dateFirstDayLastMonth, to: dateLastDayLastMonth}},
        {name: 'charged', title: 'Only charged', type: 'checkbox', change: $scope.getStats, value: false},
        {name: 'num', title: 'Count', type: 'number', change: $scope.getStats, value: 10},
        {name: 'door_id', title: 'Door', type: 'select', useId: true, options: $scope.getDoors, visible: $scope.hasDoors, change: $scope.getStats }
    ];
    $scope.hideSubmitButton = true;

    $scope.config = {
        getItems: function() {
            return $scope.topMemberEntries;
        },
        hideSearch: true,
        rowClick: function(e) { $rootScope.gotoCustomer(e.member); },
        columns: [
            {field: 'image', src: function(e) { return $rootScope.memberImage(e.member); } },
            {field: 'member.name', title: 'Name' },
            {field: 'visits', title: 'Number of visits' }
        ]
    };

    $scope.getStats();
}]);

stats.controller('ReportChangeModalCtrl', ['$rootScope', '$scope', '$controller', 'util', 'report', function($rootScope, $scope, $controller, util, report) {
    $controller('StatisticsBuilderCtrl', {$scope: $scope});
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.postUrl = '/api/stats/generic/reports/change';

    $scope.titleSuffix = function() {
        return $scope.item.name;
    };

    var r = angular.copy(report);

    $scope.item = r.data;
    $scope.item.id = r.id;
    $scope.item.customer_tab = r.customer_tab;

    util.waitFor($scope, ['info', 'reports']).then(function() {
        if ($scope.info) {
            $scope.fields.unshift({name: 'name', title: 'Name', required: true, type: 'text'});
            $scope.fields.push({name: 'customer_tab', title: 'Display as customer tab', required: false, type: 'checkbox'});
            $scope.setValues($scope.item, {dontSetInvisible: true, callChange: true});
        }
    });

    $scope.submit = function() {
        $scope.doSubmit($scope.getPreparedReportItem());
    };
}]);

stats.controller('StandardReportTemplatesCtrl', ['$rootScope', '$scope', 'reports', function ($rootScope, $scope, reports) {
    $scope.title = 'Template';
    $scope.config = {
        getItems: function() {
            return reports;
        },
        rowClick: function(e) {
            $scope.$close(e);
        },
        searchDepth: 2,
        countSuffixList: ['template', 'templates'],
        columns: [
            {field: 'data.name', title: 'Name', format: 'translated'}
        ],
        buttons: [
            {title: 'Choose', buttonClass: 'btn-success', onClick: function(t) { $scope.$close(t); } }
        ]
    };
}]);

stats.controller('StatisticsBuilderCtrl', ['$rootScope', '$scope', '$q', '$controller', '$filter', '$modal', 'server', 'util', 'propertyhelper', 'live', '$location', '$routeParams', function($rootScope, $scope, $q, $controller, $filter, $modal, server, util, propertyhelper, live, $location, $routeParams) {
    $controller('AddCtrl', {$scope: $scope});
    $scope.wideForm = true;
    $scope.ai = {
        prompt: '',
        loading: false
    };

    $scope.saveId = null;
    if ($routeParams.tab) {
        $scope.saveId = 'statsbuilder:'+$routeParams.tab;
    }

    var translate = (function() {
        var cache = {};
        var translate = $filter('translate');
        var timeout;
        return function(text) {
            var result = cache[text];
            if(!result) {
                cache[text] = result = translate(text);
                if(!timeout) {
                    timeout = setTimeout(function() {
                        timeout = null;
                        cache = {};
                    }, 2000);
                }
            }
            return result;
        };
    })();

    function getReports() {
        server.get('/api/stats/generic/reports/get', {templates: true}).then(function(result) {
            $scope.reports = result;
        });
    }
    getReports();
    live.subscribe({ type: 'report', callback: getReports, scope: $scope });

    propertyhelper.getInfo().then(function(result) {
        $scope.info = result;
        $scope.setFields();
        $scope.setSavedValues();
    });

    $scope.saveReport = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'SaveReportCtrl',
            resolve: {
                data: function() {
                    return $scope.getPreparedReportItem();
                },
                forceCustomerTab: function() {
                    return $scope.saveReportOption && $scope.saveReportOption.forceCustomerTab;
                }
            }
        }).result.then(function(report) {
            $location.path('/statistics/report/' + report.id);
        });
    };

    $scope.getButtonText = function() {
        return ($scope.saveReportOption && $scope.saveReportOption.forceCustomerTab) ? 'Search' : 'Show report';
    };

    $scope.showButton2 = function() {
        return $scope.data && $rootScope.hasPermission('Create reports');
    };

    $scope.getButtonText2 = function() {
        return ($scope.saveReportOption && $scope.saveReportOption.forceCustomerTab) ? 'Save as customer tab' : 'Save report';
    };

    $scope.submit2 = $scope.saveReport;

    $scope.getViewType = function() {
        var ap = _.findWhere($scope.fields, {name: 'aggregationperiod'});
        return ap.value && ap.value.name + 's';
    };

    var resultproperties = {};
    var resultpropertiesAfterGroupFilter = {};
    function getDatetimeProperties() {
        return resultproperties.filter(function(x) { return x.format == 'datetime' || x.format == 'date'; });
    }

    function getResultProperties() {
        return resultproperties.filter(function(p) {return !p.primary;});
    }

    function getResultPropertiesAfterGroupFilter() {
        return resultpropertiesAfterGroupFilter.filter(function(p) {return !p.primary;});
    }

    function getResultPropertiesForKeyValue() {
        return getResultProperties().filter(function(x) { return (x.format == 'price' || x.format == 'number') && !x.parent; });
    }

    function showResultProperties() {
        var d = _.findWhere($scope.fields, {name: 'datatype'}).value;
        var r = _.findWhere($scope.fields, {name: 'reporttype'}).value;
        return d && r && r.id == 'list';
    }

    function isTimeDiagram() {
        var d = _.findWhere($scope.fields, {name: 'datatype'}).value;
        var r = _.findWhere($scope.fields, {name: 'reporttype'}).value;
        return d && r && (r.id == 'line' || r.id == 'bar' || r.id == 'heatmap');
    }

    function getPropertyName(p) {
        if(p.fullname) {return p.fullname;}
        var res = '';
        if (Array.isArray(p.name)) {
            p.name.forEach(function(name) {
                if (res.length) {
                    res += ' > ';
                }
                res += translate(name);
            });
        } else {
            res = translate(p.name);
        }
        p.fullname = res;
        return res;
    }

    function showResultType() {
        var r = _.findWhere($scope.fields, {name: 'reporttype'}).value;
        var d = _.findWhere($scope.fields, {name: 'datatype'}).value;
        return r && d && (r.id == 'keyvalue' || r.id == 'line' || r.id == 'bar' || r.id == 'heatmap');
    }

    function showResultTypeProperty() {
        var res = _.findWhere($scope.fields, {name: 'resulttype'}).value;
        return showResultType() && res && res.id == 'sum';
    }

    var filteroptions = {};
    var prevDataType;
    function updateFilters() {
        var d = _.findWhere($scope.fields, {name: 'datatype'}).value;
        filteroptions.info = $scope.info;
        filteroptions.datatype = d;

        if(d.id !== prevDataType) {
            prevDataType = d.id;
            resultproperties = propertyhelper.getExpandedProperties($scope.info, d.id).map(_.clone);
            resultproperties.sort(function(a, b) {
                return getPropertyName(a) < getPropertyName(b)?-1:1;
            });
            _.findWhere($scope.fields, {name: 'filter'}).value = null;
            _.findWhere($scope.fields, {name: 'sort'}).value = null;
            _.findWhere($scope.fields, {name: 'sortDescending'}).value = false;
        }

        var group = _.findWhere($scope.fields, {name: 'groupproperty'}).value;
        if (group) {
            var groupp = group.id.split('.');
            groupp.pop();
            groupp = groupp.join('.');
            //resultpropertiesAfterGroupFilter = resultproperties.filter(function(p) { return p.format == 'price' || p.format == 'number' || p.id.startsWith(groupp); });
            resultpropertiesAfterGroupFilter = resultproperties.slice();
            resultpropertiesAfterGroupFilter.push({id: 'groupcount', name: 'Group count', format: 'number'});
            resultpropertiesAfterGroupFilter.filter(function(p) {return p.format == 'number' || p.format == 'price';}).forEach(function(p) {
                resultpropertiesAfterGroupFilter.push({id: 'grouppercent_' + p.id, name: translate('Percentage') + ' ' + getPropertyName(p), format: 'percentage' });
            });
            _.findWhere($scope.fields, {name: 'groupproperty'}).value = _.findWhere(resultpropertiesAfterGroupFilter, {id: group.id});
        } else {
            resultpropertiesAfterGroupFilter = resultproperties;
        }

        var tp = _.findWhere($scope.fields, {name: 'timeproperty'}).value;
        var dtp = getDatetimeProperties();
        var defaulttp = dtp.length ? dtp[0] : null;
        var n = tp ? _.findWhere(dtp, {id: tp.id}) || defaulttp : defaulttp;
        _.findWhere($scope.fields, {name: 'timeproperty'}).value = n;

        var p =_.findWhere($scope.fields, {name: 'properties'});
        var properties = p.value;
        if (properties) {
            properties = _.pluck(properties, 'id');
            p.value = p.options().filter(function(x) { return properties.indexOf(x.id) != -1; });
        }

        if (group) {
            if (!p.value) {
                p.value = [];
            }

            if (!_.findWhere(p.value, {id: 'groupcount'})) {
                p.value.push(_.findWhere(resultpropertiesAfterGroupFilter, {id: 'groupcount'}));
            }

            var fieldId = group.primary?group.id.replace(/\.\w+/, '.name'):group.id;
            if (!_.findWhere(p.value, {id: fieldId})) {
                var prop = _.findWhere(resultpropertiesAfterGroupFilter, {id: fieldId});
                if(prop) {p.value.push(prop);}
            }


        }

    }

    function dataTypeChange() {
        _.findWhere($scope.fields, {name: 'resulttypeproperty'}).value = null;
        _.findWhere($scope.fields, {name: 'groupproperty'}).value = null;
        _.findWhere($scope.fields, {name: 'properties'}).value = null;
        updateFilters();
    }

    function showFilter() {
        var r = _.findWhere($scope.fields, {name: 'reporttype'}).value;
        var d =_.findWhere($scope.fields, {name: 'datatype'}).value;
        return r &&r.id != 'comparision' && d;
    }

    function useTime() {
        return _.findWhere($scope.fields, {name: 'usetime'}).value || isTimeDiagram();
    }

    function showAbsoluteTimeForField(field) {
        var timeunit = _.findWhere($scope.fields, {name: 'absolutetimeunit'}).value;
        if (!useTime() || !timeunit || !_.findWhere($scope.fields, {name: 'absolutetime'}).value) {
            return false;
        }

        var tmap = {time: 'datetime', date: 'date', week: 'week', month: 'month', year: 'number'};
        return field && field.type == tmap[timeunit.id];
    }

    function showRelativeTime() {
        return useTime() && !_.findWhere($scope.fields, {name: 'absolutetime'}).value;
    }

    function filterRelativeTimePeriodTemplates() {
        return $scope.info.relativetimeperiodtemplates;
    }

    function getRelativeTimePeriodTemplateGroup(r) {
        return r.timeunit.capitalize();
    }

    function showGroupProperty() {
        var d = _.findWhere($scope.fields, {name: 'datatype'}).value;
        var r = _.findWhere($scope.fields, {name: 'reporttype'}).value;
        return d && r && (r.id == 'list' || r.id == 'keyvalue');
    }

    function showColor() {
        var d = _.findWhere($scope.fields, {name: 'datatype'}).value;
        var r = _.findWhere($scope.fields, {name: 'reporttype'}).value;
        return d && r && (r.id == 'line' || r.id == 'bar' || r.id == 'keyvalue');
    }

    function showDataType() {
        var r = _.findWhere($scope.fields, {name: 'reporttype'}).value;
        return r && r.id != 'comparision';
    }

    function showUseTime() {
        var d = _.findWhere($scope.fields, {name: 'datatype'}).value;
        return showDataType() && d && !isTimeDiagram();
    }

    function showCompareReports() {
        var r = _.findWhere($scope.fields, {name: 'reporttype'}).value;
        return r && r.id == 'comparision';
    }

    function showAggregationPeriod() {
        var d = _.findWhere($scope.fields, {name: 'datatype'}).value;
        var r = _.findWhere($scope.fields, {name: 'reporttype'}).value;
        return d && r && (r.id == 'line' || r.id == 'bar');
    }

    function getDataTypeFilter(dt) {
        var r = _.findWhere($scope.fields, {name: 'reporttype'}).value;
        if (r && r.id == 'map') {
            return dt.id == 'user' || dt.id == 'resource';
        }

        return true;
    }

    function showSort() {
        var r = _.findWhere($scope.fields, {name: 'reporttype'}).value;
        var d = _.findWhere($scope.fields, {name: 'datatype'}).value;
        return r && d && r.id == 'list';
    }

    function getSortProperties() {
        var props = _.findWhere($scope.fields, {name: 'properties'}).value;
        if (props && Array.isArray(props)) {
            return props.filter(function(p) { return p.format != 'image'; });
        }
    }

    function showSortDescending() {
        var s = _.findWhere($scope.fields, {name: 'sort'}).value;
        return showSort() && s;
    }

    function getGroupFilter(p) {
        return p.id != 'groupcount' && p.format != 'image' && !p.xf;
    }

    function getGroupProperties() {
        return resultproperties;
    }

    function getStandardTemplate() {
        $modal.open({
            templateUrl: 'views/exampletemplate.html',
            controller: 'StandardReportTemplatesCtrl',
            resolve: {
                reports: function() {
                    return $scope.reports;
                }
            }
        }).result.then(function(template) {
            util.setValues($scope.getFields ? $scope.getFields() : $scope.fields, template.data, {dontSetInvisible: true, callChange: true});
        });
    }

    $scope.ai.loading = false;
    $scope.createAiReport = function() {
        $scope.setFields();
        $scope.ai.loading = true;
        server.post('/api/stats/generic/ai', {prompt: $scope.ai.prompt}).then
        (response => {
            $scope.ai.loading = false;
            if (response.success) {
                $scope.resetForm($scope);
                _.findWhere($scope.fields, {name: 'filter'}).value = null;
                _.findWhere($scope.fields, {name: 'sort'}).value = null;
                _.findWhere($scope.fields, {name: 'sortDescending'}).value = false;
                util.setValues($scope.getFields ? $scope.getFields() : $scope.fields, response.data, {dontSetInvisible: true, callChange: true});
            } else {
                $scope.ai.error = response.data.message || 'Error creating report';
            }
        });
    };

    $scope.setFields = function() {
        $scope.fields = [
            {type: 'button', buttonTitle: 'Choose from standard templates', buttonClass: 'btn btn-success', click: getStandardTemplate },
            {name: 'reporttype', title: 'Report type', required: true, type: 'select', options: function() { return $scope.info.reporttypes; }, useId: true, orderPredicate: 'translated' },
            {name: 'datatype', title: 'Data type', required: true, type: 'select', options: function() { return $scope.info.datatypes; }, optionsFilter: getDataTypeFilter, useId: true, change: dataTypeChange, orderPredicate: 'translated', visible: showDataType },
            {name: 'usetime', title: 'Filter on time', required: true, type: 'checkbox', visible: showUseTime },
            {name: 'timeproperty', title: 'Time property', required: true, type: 'select', options: getDatetimeProperties, useId: true, visible: useTime, getName: getPropertyName, orderPredicate: getPropertyName },
            {name: 'absolutetime', title: 'Specify time interval', required: true, type: 'checkbox', visible: useTime },
            {name: 'absolutetimeunit', title: 'Time unit', required: true, type: 'select', options: function() { return $scope.info.timeunittypes; }, useId: true, visible: function() { return useTime() && !showRelativeTime(); } },
            {name: 'relativetime', title: 'Time period', required: true, type: 'select', options: filterRelativeTimePeriodTemplates, useId: true, visible: showRelativeTime, group: getRelativeTimePeriodTemplateGroup },

            // Time
            {name: 'absolutetimefrom', title: 'From', required: true, type: 'datetime', visible: showAbsoluteTimeForField },
            {name: 'absolutetimeto', title: 'To', required: true, type: 'datetime', visible: showAbsoluteTimeForField },

            // Date
            {name: 'absolutetimefrom', title: 'From', required: true, type: 'date', visible: showAbsoluteTimeForField },
            {name: 'absolutetimeto', title: 'To', required: true, type: 'date', visible: showAbsoluteTimeForField },

            // Week
            {name: 'absolutetimefrom', title: 'From', required: true, type: 'week', visible: showAbsoluteTimeForField },
            {name: 'absolutetimeto', title: 'To', required: true, type: 'week', visible: showAbsoluteTimeForField },

            // Month
            {name: 'absolutetimefrom', title: 'From', required: true, type: 'month', visible: showAbsoluteTimeForField },
            {name: 'absolutetimeto', title: 'To', required: true, type: 'month', visible: showAbsoluteTimeForField },

            // Year
            {name: 'absolutetimefrom', title: 'From', required: true, type: 'number', min: 2000, max: 2100, visible: showAbsoluteTimeForField },
            {name: 'absolutetimeto', title: 'To', required: true, type: 'number', min: 2000, max: 2100, visible: showAbsoluteTimeForField },

            {name: 'filter', title: 'Filter', required: true, type: 'filter', options: filteroptions, visible: showFilter },
            {name: 'aggregationperiod', title: 'Aggregation period', required: true, type: 'select', options: function() { return $scope.info.aggregationperiodtypes; }, useId: true, visible: showAggregationPeriod },
            {name: 'resulttype', title: 'Result type', required: true, type: 'select', options: function() { return $scope.info.resulttypes; }, useId: true, visible: showResultType },
            {name: 'resulttypeproperty', title: 'Result type property', required: true, type: 'select', options: getResultPropertiesForKeyValue, useId: true, visible: showResultTypeProperty, getName: getPropertyName },
            {name: 'round', title: 'Round to the nearest integer', required: false, type: 'checkbox', visible: showResultTypeProperty },
            {name: 'groupproperty', title: 'Group property', required: false, type: 'select', options: getGroupProperties, useId: true, visible: showGroupProperty, optionsFilter: getGroupFilter, getName: getPropertyName, change: updateFilters, orderPredicate: 'fullname' },
            {name: 'properties', title: 'Result properties', required: true, type: 'multiselect', version: 2, options: getResultPropertiesAfterGroupFilter, useId: true, visible: showResultProperties, getName: getPropertyName, },
            {name: 'color', title: 'Color', required: true, type: 'color', visible: showColor },
            {name: 'sort', title: 'Sort on', required: false, type: 'select', visible: showSort, options: getSortProperties, useId: true, getName: getPropertyName },
            {name: 'sortDescending', title: 'Sort descending', required: false, type: 'checkbox', visible: showSortDescending },
            {name: 'subtitle', title: 'Subtitle', required: false, type: 'text', visible: showSort },
            {name: 'comparereports', title: 'Reports', required: true, type: 'multiselect', options: function() { return $scope.reports; }, optionsFilter: function(r) { return r.data.reporttype == 'line' || r.data.reporttype == 'bar'; }, useId: true, visible: showCompareReports, getName: function(r) { return r.data.name; }, orderPredicate: function(r) { return r.data.name; } }
        ];

        _.findWhere($scope.fields, {name: 'absolutetimeunit'}).value = _.findWhere($scope.info.timeunittypes, {id: 'date'});
        _.findWhere($scope.fields, {name: 'relativetime'}).value = _.findWhere(filterRelativeTimePeriodTemplates(), {id: 'lastmonth'});
        _.findWhere($scope.fields, {name: 'aggregationperiod'}).value = _.findWhere($scope.info.aggregationperiodtypes, {id: 'date'});
        _.findWhere($scope.fields, {name: 'absolutetimefrom', type: 'number'}).value = new Date().getFullYear() - 1;
        _.findWhere($scope.fields, {name: 'absolutetimeto', type: 'number'}).value = new Date().getFullYear() - 1;
        _.findWhere($scope.fields, {name: 'absolutetimefrom', type: 'date'}).value = Date.firstDayLastMonth();
        _.findWhere($scope.fields, {name: 'absolutetimeto', type: 'date'}).value = Date.lastDayLastMonth();
        _.findWhere($scope.fields, {name: 'absolutetimefrom', type: 'month'}).value = new Date().lastMonth();
        _.findWhere($scope.fields, {name: 'absolutetimeto', type: 'month'}).value = new Date().lastMonth();
        _.findWhere($scope.fields, {name: 'absolutetimefrom', type: 'week'}).value = new Date().lastMonth();
        _.findWhere($scope.fields, {name: 'absolutetimeto', type: 'week'}).value = new Date().lastMonth();
        _.findWhere($scope.fields, {name: 'absolutetimefrom', type: 'datetime'}).value = Date.firstDayLastMonth();
        _.findWhere($scope.fields, {name: 'absolutetimeto', type: 'datetime'}).value = Date.lastDayLastMonth();
        _.findWhere($scope.fields, {name: 'resulttype'}).value = _.findWhere($scope.info.resulttypes, {id: 'count'});
        _.findWhere($scope.fields, {name: 'color'}).value = util.getRandomColor();


        if($scope.statisticsBuilderOption && $scope.statisticsBuilderOption.presetCustomer) {
            _.findWhere($scope.fields, {name: 'reporttype'}).value = _.findWhere($scope.info.reporttypes, {id: 'list'});
            _.findWhere($scope.fields, {name: 'reporttype'}).visible = function() {return false;};
            _.findWhere($scope.fields, {name: 'reporttype'}).save = true;
            _.findWhere($scope.fields, {name: 'datatype'}).value = _.findWhere($scope.info.datatypes, {id: 'user'});
            _.findWhere($scope.fields, {name: 'datatype'}).visible = function() {return false;};
            _.findWhere($scope.fields, {name: 'datatype'}).save = true;
            dataTypeChange();
            _.findWhere($scope.fields, {name: 'properties'}).value = [
                _.findWhere(getResultProperties(), {id: 'image'}),
                _.findWhere(getResultProperties(), {id: 'name'}),
                _.findWhere(getResultProperties(), {id: 'age'})
            ];
        }

    };

    $scope.getKeyValuePropertyFormat = function() {
        var prop = _.findWhere($scope.fields, {name: 'keyvalueproperty'}).value;
        return prop.format;
    };

    function prependDatatype(datatype, r) {
        if (r.content) {
            r.content.forEach(function(r) {
                prependDatatype(datatype, r);
            });
        } else {
            r.lhs = datatype + '.' + r.lhs;
        }
    }

    $scope.getPreparedReportItem = function() {
        var item = $scope.getSubmitItem();
        if (item.filter) {
            item.filter = angular.copy(item.filter);
            prependDatatype(item.datatype, item.filter);
        }
        return item;
    };

    $scope.canSubmit = function() {
        if (!Array.isArray($scope.fields)) {
            return false;
        }

        var r = _.findWhere($scope.fields, {name: 'reporttype'}).value;
        if (r && r.id == 'comparision') {
            var c = _.findWhere($scope.fields, {name: 'comparereports'}).value;
            if (!c || c.length < 2) {
                return false;
            }

            var aggregationperiod;
            var allsame = true;
            c.forEach(function(x) {
                if (!aggregationperiod) {
                    aggregationperiod = x.data.aggregationperiod;
                }

                if (aggregationperiod != x.data.aggregationperiod) {
                    allsame = false;
                }
            });
            return allsame;
        }

        return true;
    };

    $scope.loadingStatus = {};
    $scope.submit = function() {
        $scope.data = null;
        $scope.error = false;
        $scope.loadingStatus.loading = true;
        $scope.reportRequest = $scope.getPreparedReportItem();

        if($scope.statisticsBuilderOption && $scope.statisticsBuilderOption.presetCustomer) {
            var filter = $scope.reportRequest.filter;
            if(!filter) {
                $scope.reportRequest.filter = {
                    type: 'expression',
                    lhs: 'removed',
                    operation: 'eq',
                    rhs: '{null}'
                };
            } else {
                $scope.reportRequest.filter = {
                    type: 'and',
                    content: [{
                        type: 'expression',
                        lhs: 'removed',
                        operation: 'eq',
                        rhs: '{null}'
                    }, filter]
                };
            }
        }

        server.post('/api/stats/generic', $scope.reportRequest, null).then(function(result) {
            if (result.success) {
                $scope.data = result.data;
            } else {
                $scope.error = true;
            }

            $scope.loadingStatus.loading = false;
        });

        if ($scope.saveId) {
            $scope.pubsub.publish($scope.saveId, $scope.getSubmitItem());
        }
    };

    $scope.setSavedValues = function() {
        if ($scope.saveId) {
            $scope.pubsub($scope.saveId, function(data) {
                util.setValues($scope.fields, data);
                $scope.pubsub.unsubscribe();
            }, true);
        }
    };

}]);

stats.controller('GenericReportsCtrl', ['$rootScope', '$scope', '$location', '$filter', '$modal', 'confirm', 'server', function($rootScope, $scope, $location, $filter, $modal, confirm, server) {
    function gotoReport(report) {
        $location.path('/statistics/report/' + report.id);
    }

    $scope.newReport = function() {
        $location.path('/statistics/newreport');
    };

    $scope.orderSpecialReport = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'OrderSpecialReportCtrl',
            windowClass: 'huge-modal-window'
        });
    };

    function changeReport(report) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'ReportChangeModalCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                report: function() {
                    return report;
                }
            }
        });
    }

    function copyReport(report) {
        report = angular.copy(report.data);
        delete report.id;
        report.name = $filter('translate')('Copy of') + ' ' + $filter('translate')(report.name);

        server.post('/api/stats/generic/reports/add', report, null).then(function(result) {
            if (result.success) {
                changeReport(result.data);
            }
        });
    }

    function removeReport(report) {
        confirm.show('Are you sure you want to remove the report?').then(function() {
            server.post('/api/stats/generic/reports/remove', null, {id: report.id}, '{0} was removed', 'Failed to remove {0}', 'Report');
        });
    }

    $scope.config = {
        filter: [],
        api: {
            url: '/api/stats/generic/reports/get',
            args: {templates: false},
            triggers: [{ type: 'report' }],
            transform: function(r) {
                r.name = $filter('translate')(r.data.name);
            }
        },
        rowClick: gotoReport,
        searchDepth: 2,
        countSuffixList: ['report', 'reports'],
        columns: [
            {field: 'name', title: 'Report' },
            {field: 'customer_tab', title: 'Customer tab', format: 'bool'},
            {field: 'created', title: 'Created', format: 'datetime'}
        ],
        orderColumn: 'name',
        buttons: [
            {title: 'Show', onClick: gotoReport },
            {title: 'Change', buttonClass: 'btn-warning', onClick: changeReport },
            {title: 'Copy', buttonClass: 'btn-info', onClick: copyReport },
            {title: 'Remove', buttonClass: 'btn-danger', onClick: removeReport }
        ]
    };
}]);

stats.controller('ShowReportCtrl', ['$scope', '$routeParams', 'server', function($scope, $routeParams, server) {
    $scope.option = {
        showChange: true
    };

    server.get('/api/stats/generic/info').then(function(result) {
        _.keys(result.properties).forEach(function(dt) {
            var props = result.properties[dt];
            props.forEach(function(p) {
                if (p.datatype) {
                    p.datatype = _.findWhere(result.datatypes, {id: p.datatype});
                }
                if (p.joinedproperty) {
                    p.joinedproperty = _.findWhere(result.datatypes, {id: p.joinedproperty});
                }
            });
        });

        $scope.info = result;
        $scope.reportId = $routeParams.reportId;
    });
}]);

stats.controller('SaveReportCtrl', ['$rootScope', '$scope', '$controller', 'data', 'forceCustomerTab', function($rootScope, $scope, $controller, data, forceCustomerTab) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = forceCustomerTab ? 'Save as customer tab' : 'Create report';
    $scope.postUrl = '/api/stats/generic/reports/add';
    $scope.callCloseOnSuccess = true;
    $scope.successTitle = '{0} was added';
    $scope.failedTitle = 'Failed to add {0}';
    $scope.itemTitle = 'Report';

    $scope.fields = [
        {name: 'name', title: 'Name', required: true, type: 'text' },
        {name: 'customer_tab', title: 'Display as customer tab', required: false, type: 'checkbox', visible: function(){return !forceCustomerTab;} }
    ];

    $scope.getSubmitItem = function() {
        var item = data;
        item.name = _.findWhere($scope.fields, {name: 'name'}).value;
        item.customer_tab = _.findWhere($scope.fields, {name: 'customer_tab'}).value;

        if (forceCustomerTab) {
            item.customer_tab = true;
        }

        return item;
    };
}]);

stats.controller('OrderSpecialReportCtrl', ['$rootScope', '$scope', '$controller', 'server', function ($rootScope, $scope, $controller, server) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = 'Order special report';
    $scope.submitTitle = 'Send order';
    $scope.loadingStatus = {};

    $scope.fields = [
        { name: '_', hint: 'ORDER_SPECIALREPORT_HINT', hintClass: 'alert-info' },
        { name: 'description', title: 'Description', required: true, type: 'htmleditor' }
    ];

    $scope.submit = function () {
        $scope.loadingStatus.loading = true;
        var message = 'From: ' + $rootScope.getHost() + '<br><br>' + $scope.getSubmitItem().description;
        var mail = { staffs: [$rootScope.superUserId], message: message, from: $rootScope.currentStaff.name, subject: 'Best\xE4llning av ny rapport', replyTo: $rootScope.currentStaff.mail };
        server.post('/api/mail/send', mail, null, 'Order sent', 'Failed to send order').then(function() {
            $scope.$close();
            $scope.loadingStatus.loading = false;
        });
    };
}]);
